var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_5294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 22.3656V21.7259L13.3637 21.6684C9.06461 21.2805 5.69414 17.6702 5.69414 13.2889V11.4456C5.69414 11.4078 5.70788 11.3805 5.72682 11.3616C5.74577 11.3426 5.77305 11.3289 5.81081 11.3289C5.84856 11.3289 5.87585 11.3426 5.89479 11.3616C5.91373 11.3805 5.92747 11.4078 5.92747 11.4456V13.3006C5.92747 17.8172 9.60087 21.4906 14.1175 21.4906C18.6341 21.4906 22.3075 17.8172 22.3075 13.3006V11.4572C22.3075 11.4195 22.3212 11.3922 22.3402 11.3733C22.3591 11.3543 22.3864 11.3406 22.4241 11.3406C22.4762 11.3406 22.5361 11.387 22.5408 11.4587V13.2889C22.5408 17.6709 19.1582 21.2914 14.8728 21.6683L14.2341 21.7244V22.3656V24.8506C14.2341 24.8883 14.2204 24.9156 14.2015 24.9346C14.1825 24.9535 14.1552 24.9672 14.1175 24.9672C14.0797 24.9672 14.0524 24.9535 14.0335 24.9346C14.0145 24.9156 14.0008 24.8883 14.0008 24.8506V22.3656Z",
    fill: "#454551",
    stroke: "#454551",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1166 2.33203C11.27 2.33203 8.95996 4.64203 8.95996 7.4887V13.462C8.95996 16.3087 11.27 18.6187 14.1166 18.6187C16.9633 18.6187 19.2733 16.3087 19.2733 13.462V7.4887C19.2733 4.64203 16.9633 2.33203 14.1166 2.33203ZM15.645 10.4404C15.5633 10.7437 15.295 10.942 14.9916 10.942C14.9333 10.942 14.875 10.9304 14.8166 10.9187C14.3616 10.7904 13.8833 10.7904 13.4283 10.9187C13.055 11.0237 12.6933 10.802 12.6 10.4404C12.495 10.0787 12.7166 9.70536 13.0783 9.61203C13.7666 9.42536 14.49 9.42536 15.1783 9.61203C15.5283 9.70536 15.7383 10.0787 15.645 10.4404ZM16.2633 8.17703C16.1583 8.45703 15.9016 8.62036 15.6216 8.62036C15.54 8.62036 15.47 8.6087 15.3883 8.58536C14.5716 8.28203 13.6616 8.28203 12.845 8.58536C12.495 8.7137 12.0983 8.52703 11.97 8.17703C11.8416 7.82703 12.0283 7.43036 12.3783 7.3137C13.4983 6.90536 14.735 6.90536 15.855 7.3137C16.205 7.44203 16.3916 7.82703 16.2633 8.17703Z",
    fill: "#454551"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_5294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.2f52f56bd115dc0c2818928fa45b3ed6.svg";
export { ForwardRef as ReactComponent };